/* import __COLOCATED_TEMPLATE__ from './sub-category-item.hbs'; */
import CategoryListItem from "discourse/components/category-list-item";
import TEMPLATE from "./sub-category-item.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, CategoryListItem.extend({}));